import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SystemApiClient } from '../clients/system-api/SystemApiClientp';
import { PaginationArgs, UserProfileDataPaginationDataAdministrationResult } from '../clients/system-api/SystemApiClient';
@Injectable({
  providedIn: 'root'
})
export class EmployeeService {
  constructor(private systemApiClient: SystemApiClient) { }

  retrieveAllUsers(roleId: number | undefined, date: Date | undefined = undefined, serviceId: number | undefined = undefined): Observable<UserProfileDataPaginationDataAdministrationResult> {
    return this.systemApiClient.retrieveAllUsers(roleId, date, serviceId);
  }


}
